import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/router/layouts'
import LayoutDefault from '@/router/layouts/layout-default'
import LayoutOrder from '@/router/layouts'
import { API_BARCODE_PRINT, API_EXPORT_STORAGE_DETAIL, API_IMPORT_STORAGE_DETAIL, API_STORAGE_CANCEL, API_STORAGE_DETAIL, API_STORAGE_IMPORT, API_STORAGE_RECREATE, API_STORAGE_SUCCESS, API_STORAGE_UPDATE, API_SWITCH_STORAGE_CREATE, API_SWITCH_STORAGE_DETAIL, API_SWITCH_STORAGE_EDIT } from '../utils/contants';
Vue.use(Router)
export const constantRoutes = [
  {
    path: "/login",
    name: "Đăng nhập",
    redirect: '/token'
  },
  {
    path: "/logout",
    name: "Đăng Xuất",
    component: () => import("@/router/views/logout"),
  },
  {
    path: "/",
    redirect: '/homepage',
    name: "Homepage",
    component: () => import("@/pages/landing-page/home"),
  },
  {
    path: "/homepage",
    name: "Homepage",
    component: () => import("@/pages/landing-page/home"),
  },  
  {
    path: "/pricing",
    name: "pricing",
    component: () => import("@/pages/landing-page/pricing"),
  },

  {
    path: "/home",
    name: "Homepage",
    component: () => import("@/pages/landing-page/home"),
  },
  {
    path: "/components",
    name: "components",
    hidden: true,
    component: Layout,
    children: [
      {
        path: "/",
        name: "demo",
        meta: { authRequired: false, active: false },
        component: () => import("@/pages/demo/demo.vue"),
      }
    ] 
  },

  {
    path: "/setting",
    name: "Cấu hình mpos",
    hidden: true,
    component: Layout,
    children: [
      {
        path: "",
        name: "Cấu hình",
        meta: { authRequired: true, active: true },
        component: () => import("@/pages/setting/setting"),
      },
      {
        path: "merchant-info",
        name: "Thông tin doanh nghiệp",
        component: () => import("@/pages/setting/merchant-info"),
      },
      {
        path: "payon-connect",
        name: "Liên kết Payon",
        component: () => import("@/pages/setting/payon-connect"),
      },
      {
        path: "mpos-connect",
        name: "mposConnect",
        component: () => import("@/pages/setting/mpos-connect"),
      },
      {
        path: "config",
        name: "mposConnect",
        component: () => import("@/pages/setting/config"),
      },
      {
        path: "mpos-remove-connect",
        name: "Gỡ liên kết Mpos",
        component: () => import("@/pages/setting/mpos-remove-connect"),
      },
      {
        path: "mpos-connect-next",
        name: "Gỡ liên kết Mpos thành công",
        component: () => import("@/pages/setting/mpos-connect-next"),
      },
      {
        path: "convert-data",
        name: "Chuyển đổi dữ liệu nextshop",
        component: () => import("@/pages/setting/convert-data"),
      },
      {
        path: "/migrate",
        name: "Chuyển đổi dữ liệu nextshop",
        component: () => import("@/pages/setting/convert-data"),
      },
      {
        path: "/config/sync-data",
        name: "syncData",
        component: () => import("@/pages/config/syncData"),
      },
      {
        path: "/setting/prints",
        name: "formatPrints",
        component: () => import("@/pages/setting/prints/list"),
        permission: "NSH_PRINT_TEMP_VIEW"
      }
    ]
  },
  {
    path: "/setting",
    name: "Cấu hình gian hàng trực tuyến",
    hidden: true,
    component: LayoutDefault,
    children: [
      {
        path: "create-online-store",
        name: "Cấu hình gian hàng trực tuyến",
        component: () => import("@/pages/setting/create-online-store"),
      },
    ]
  },
  {
    path: "/prints",
    name: "Cấu hình mẫu in",
    hidden: true,
    component: LayoutDefault,
    children: [
      {
        path: "/setting/prints/edit",
        name: "formatPrintsEdit",
        component: () => import("@/pages/setting/prints/edit"),
        permission: "NSH_PRINT_TEMP_UPDATE"
      },
    ]
  },
  {
    path: "/role",
    name: "Quyền người dùng",
    hidden: true,
    component: Layout,
    children: [
      {
        path: "",
        name: "Danh sách quyền",
        component: () => import("@/pages/role/role-list"),
      },
      {
        path: "edit/:id",
        name: "Cập nhật thông tin quyền",
        component: () => import("@/pages/role/role-edit"),
      },
      {
        path: "create",
        name: "Thêm mới quyền",
        component: () => import("@/pages/role/role-create"),
      },
      {
        path: "/permissions/init",
        name: "Thêm mới quyền vào nhóm quyền",
        component: () => import("@/pages/role/permissions-init"),
      },
      {
        path: "/permissions/delete",
        name: "Xóa quyền",
        component: () => import("@/pages/role/permissions-delete"),
      },
    ]
  },
  {
    path: "/package-select",
    name: "package",
    component: () => import("@/pages/package/package-select"),
  },
  {
    path: "/package-select-v2",
    name: "package",
    component: () => import("@/pages/package/package-select-v2"),
  },

  {
    path: "/token",
    name: "token",
    component: () => import("@/router/views/token"),
  },
  {
    path: '/404',
    component: () => import('./views/_404'),
    hidden: true
  },
  {
    path: '/forbidden',
    component: () => import('./views/forbidden'),
    hidden: true
  },
  {
    path: "/not-permission",
    name: "",
    component: () => import("@/router/views/not-permission"),
  },
  {
    path: "/barcode/choose",
    name: "In mã vạch",
    component: () => import("@/pages/barcode/choose.vue"),
    permission: "NSH_ITEM_PROD_CREATE"
  },
  {
    path: `${API_BARCODE_PRINT}/preview`,
    name: "Tạo mẫu tem barcode",
    component: () => import("@/pages/barcode/preview"),
  },
  //pos
  {
    path: `/pos`,
    name: "Bán hàng",
    component: LayoutDefault,
    listPermission: ["NSH_ORDER_CREATE"],
    hidden: true,
    children: [
      {
        path: "",
        name: "Bán hàng",
        component: () => import("@/pages/V2/pos/pos.vue"),
      }
    ]
  },
  {
    path: `/pos`,
    name: "Bán hàng",
    component: LayoutDefault,
    hidden: true,
    children: [
      {
        path: `pos-detail/:id`,
        name: "Thông tin đơn hàng",
        component: () => import("@/pages/pos/pos-detail-v2.vue"),
      }
    ]
  },
  //Location
  {
    path: "/location-list",
    name: "Chi nhánh",
    meta: { title: 'Chi nhánh', icon: 'fa-store'},
    hidden: true,
    component: Layout,
    children: [
      {
        path: "",
        name: "Danh sách chi nhánh",
        meta: { title: 'Danh sách chi nhánh', icon: ''},
        component: () => import("@/pages/location/locationList"),
      },
      {
        path: "location-create",
        name: "Thêm mới chi nhánh",
        meta: { title: 'Thêm mới chi nhánh', icon: ''},
        component: () => import("@/pages/location/location-create"),
      },
      {
        path: "location-update/:id",
        name: "Cập nhật thông tin chi nhánh",
        meta: { title: 'Cập nhật thông tin chi nhánh', icon: ''},
        component: () => import("@/pages/location/location-update"),
      },
      {
        path: "location-detail/:id",
        name: "Chi tiết chi nhánh",
        meta: { title: 'Thêm mới chi nhánhChi tiết chi nhánh', icon: ''},
        component: () => import("@/pages/location/location-detail"),
      }
    ]
  },
  //Sidebar
  {
    path: "/dashboard",
    name: "Tổng quan",
    meta: { title: 'Tổng quan', icon: 'fa-house'},
    component: Layout,
    listPermission: ["NSH_REPORT_SUMMARY"],
    children: [
      {
        path: "",
        name: "Tổng quan",
        meta: { title: 'Tổng quan', icon: 'icon-home'},
        component: () => import("@/pages/dashboard/dashboard"),
      }
    ]
  },
  {
    path: "/report-revenue",
    name: "Báo cáo",
    meta: { title: 'Báo cáo', icon: 'fa-chart-line'},
    component: Layout,
    listPermission: ["NSH_REPORT_SELL", "NSH_REPORT_PARTNER"],
    children: [
      {
        path: "",
        name: "Báo cáo bán hàng",
        meta: { title: 'Báo cáo bán hàng'},
        component: () => import("@/pages/report/report-revenue"),
        permission: "NSH_REPORT_SELL"
      },
      /*
      {
        path: "/report-product",
        name: "Báo cáo sản phẩm",
        meta: { title: 'Báo cáo sản phẩm'},
        component: () => import("@/pages/report/report-product"),
        permission: "NSH_REPORT_SELL"
      },

      {
        path: "/report-debit",
        name: "Báo cáo công nợ",
        meta: { title: 'Báo cáo công nợ'},
        component: () => import("@/pages/report/report-debit"),
        permission: "NSH_REPORT_PARTNER"
      },
      */
      {
        path: "/report-list/revenue-by-time",
        name: "Doanh thu theo thời gian",
        hidden: true,
        component: () => import("@/pages/report/revenue/revenue-by-time-v2"),
      },
      
      {
        path: "/report-list/revenue-by-product",
        name: "Doanh thu theo sản phẩm",
        hidden: true,
        component: () => import("@/pages/report/revenue/revenue-by-product-v2"),
      },
    
      {
        path: "/report-list/revenue-by-customer",
        name: "Doanh thu theo khách hàng",
        hidden: true,
        component: () => import("@/pages/report/revenue/revenue-by-customer-v2"),
      },

      {
        path: "/report-list/profit-by-time",
        name: "Lợi nhuận theo thời gian",
        hidden: true,
        component: () => import("@/pages/report/profit/profit-by-time"),
      },

      {
        path: "/report-list/profit-by-product",
        name: "Phương thức TT",
        hidden: true,
        component: () => import("@/pages/report/profit/profit-by-product"),
      },

      {
        path: "/report-list/revenue-by-payment",
        name: "Lợi nhuận theo sản phẩm",
        hidden: true,
        component: () => import("@/pages/report/payment/revenue-by-payment"),
      },
      {
        path: "/report-list/bestsale-by-product",
        name: "Sản phẩm bán chạy",
        hidden: true,
        component: () => import("@/pages/report/product/bestsale-by-product"),
      },
      {
        path: "/report-list/overview-by-product",
        name: "Sản phẩm bán chạy",
        hidden: true,
        component: () => import("@/pages/report/product/overview-by-product"),
      },
      {
        path: "/report-debit/debit-by-partner",
        name: "Công nợ khách hàng",
        hidden: true,
        component: () => import("@/pages/report/debt/debit-by-partner")
      },
      {
        path: "/report-debit/debit-by-supplier",
        name: "Công nợ nhà cung cấp",
        hidden: true,
        component: () => import("@/pages/report/debt/debit-by-supplier")
      },
      {
        path: "/report-debit/debit-by-shipper",
        name: "Công nợ shipper",
        hidden: true,
        component: () => import("@/pages/report/debt/debit-by-shipper")
      }
    ]
  },
  {
    path: "/pos",
    name: "Bán hàng",
    meta: { title: 'Bán hàng', icon: 'fa-cash-register'},
    component: LayoutDefault,
    listPermission: ["NSH_ORDER_CREATE"],
    children: [
      {
        path: "",
        name: "Bán hàng",
        meta: { title: 'Bán hàng', icon: 'icon-home'},
        component: () => import("@/pages/V2/pos/pos.vue"),
      }
    ]
  },
  
  {
    path: "/store-merchant",
    name: "Gian hàng trực tuyến",
    meta: { title: 'Gian hàng trực tuyến', icon: 'fa-store'},
    component: LayoutOrder,
    listPermission: ["NSH_ONLINE_STORE_VIEW", "NSH_ONLINE_STORE_SETTING"],
    children: [
      {
        path: "",
        name: "Gian hàng trực tuyến",
        meta: { title: 'Gian hàng trực tuyến', icon: 'fa-store'},
        component: () => import("@/pages/store-merchant/product-list"),
      },
      {
        path: "create-store-instruction",
        name: "Hướng dẫn tạo gian hàng trực tuyến",
        meta: { title: 'Hướng dẫn tạo gian hàng trực tuyến', icon: 'fa-store'},
        hidden: true,
        component: () => import("@/pages/store-merchant/create-store-instruction"),
      },
      {
        path: "product-detail/:id",
        name: "merchant-product-detailn",
        meta: { title: 'merchant-product-detail', icon: 'fa-store'},
        hidden: true,
        component: () => import("@/pages/store-merchant/product-detail"),
      },
      {
        path: "overview",
        name: "Tổng quan gian hàng",
        meta: { title: 'Tổng quan gian hàng', icon: 'fa-store'},
        hidden: true,
        component: () => import("@/pages/store-merchant/overview"),
      }
    ]
  },
  
  {
    path: "/orders",
    name: "Đơn hàng",
    meta: { title: 'Đơn hàng', icon: 'fa-clipboard-list'},
    component: Layout,
    listPermission: ["NSH_ORDER_VIEW", "NSH_ORDER_RETURN"],
    children: [
      {
        path: "",
        name: "Danh sách đơn hàng",
        meta: { title: 'Danh sách đơn hàng', icon: 'fa-clipboard-list'},
        component: () => import("@/pages/orders/ordersListV2"),
        permission: "NSH_ORDER_VIEW"
      },
      {
        path: "orders-return",
        name: "Danh sách trả hàng",
        meta: { title: 'Danh sách trả hàng', icon: 'fa-clipboard-list'},
        component: () => import("@/pages/orders/orders-return"),
        permission: "NSH_ORDER_RETURN"
      }
    ]
  },
  {
    path: "/orders-return",
    name: "Đơn hàng trả",
    hidden: true,
    meta: { title: 'Đơn hàng trả', icon: 'icon-logistics-box' },
    component: LayoutDefault,
    children: [
      {
        path: "create/:id",
        name: "Tạo đơn hàng trả",
        meta: { title: 'Tạo đơn hàng trả', icon: ''},
        hidden: true,
        component: () => import("@/pages/orders-return/orders-return-create"),
      },
      {
        path: "detail/:id",
        name: "Tạo đơn hàng trả",
        meta: { title: 'Tạo đơn hàng trả', icon: ''},
        hidden: true,
        component: () => import("@/pages/orders-return/orders-return-detail"),
      }
    ]
  },
  /*
  {
    path: "/orders-delivery",
    name: "Giao hàng",
    meta: { title: 'Giao hàng', icon: 'fa-truck'},
    component: Layout,
    listPermission: ["NSH_ORDER_VIEW"],
    children: [
      {
        path: "",
        name: "Danh sách đơn giao hàng",
        meta: { title: 'Danh sách đơn giao hàng'},
        component: () => import("@/pages/orders-delivery/delivery-orders-list"),
        permission: "NSH_ORDER_VIEW"
      },
      {
        path: "/partners",
        name: "Đối tác giao hàng",
        meta: { title: 'Đối tác giao hàng'},
        component: () => import("@/pages/orders-delivery/delivery-partners"),
        permission: "NSH_ORDER_VIEW"
      },
    ]
  },
  */
  {
    path: "/orders-delivery",
    name: "Đơn giao hàng",
    hidden: true,
    meta: { title: 'Giao hàng', icon: 'icon-logistics-box' },
    component: LayoutDefault,
    children: [
      {
        path: "edit-delivery-order/:id",
        name: "Chỉnh sửa đơn giao hàng",
        meta: { title: 'Chỉnh sửa đơn giao hàng'},
        hidden: true,
        component: () => import("@/pages/orders-delivery/edit-delivery-order"),
      },
      {
        path: "delivery-order-detail/:id",
        name: "Chi tiết đơn giao hàng",
        meta: { title: 'Chi tiết đơn giao hàng'},
        hidden: true,
        component: () => import("@/pages/orders-delivery/delivery-order-detail"),
      },
      {
        path: "create-shipper",
        name: "Thêm mới shipper",
        meta: { title: 'Thêm mới shipper'},
        hidden: true,
        component: () => import("@/pages/orders-delivery/create-shipper"),
      },
      {
        path: "edit-shipper/:id",
        name: "Sửa thông tin shipper",
        meta: { title: 'Sửa thông tin shipper'},
        hidden: true,
        component: () => import("@/pages/orders-delivery/edit-shipper"),
      },
      {
        path: "shipper-info/:id",
        name: "Thông tin shipper",
        meta: { title: 'Thông tin shipper'},
        hidden: true,
        component: () => import("@/pages/orders-delivery/shipper-info"),
      },
    ]
  },
  {
    path: "/partners",
    name: "ĐTGH",
    hidden: true,
    meta: { title: 'Giao hàng', icon: 'icon-logistics-box' },
    component: LayoutDefault,
    children: [
      {
        path: "delivery-provider",
        name: "delivery-provider",
        meta: { title: 'Hãng vận chuyển'},
        hidden: true,
        component: () => import("@/pages/orders-delivery/delivery-provider"),
      },
      {
        path: "integrate-app",
        name: "integrate-app",
        meta: { title: 'Tích hợp ứng dụng'},
        hidden: true,
        component: () => import("@/pages/orders-delivery/integrate-app"),
      },
      {
        path: "integrate-app-otp",
        name: "integrate-app-otp",
        meta: { title: 'Nhập mã OTP'},
        hidden: true,
        component: () => import("@/pages/orders-delivery/integrate-app-otp"),
      },
    ]
  },
  {
    path: "/items",
    name: "Sản phẩm",
    component: Layout,
    meta: { title: 'Sản phẩm', icon: 'fa-tags' },
    listPermission: ["NSH_ITEM_PROD_VIEW", "NSH_ITEM_CATEG_VIEW", "NSH_ITEM_TYPE_VIEW", "NSH_ITEM_PROD_CREATE"],
    children: [
      {
        path: "",
        name: "Danh sách sản phẩm",
        meta: { title: 'Danh sách sản phẩm', icon: 'icon-logistics-box'},
        component: () => import("@/pages/items/items-list"),
        permission: "NSH_ITEM_PROD_VIEW"
      },
      {
        path: "batch",
        name: "Danh sách lô và HSD",
        meta: { title: 'Lô - HSD', icon: ''},
        component: () => import("@/pages/items/batch"),
        permission: "NSH_ITEM_PROD_VIEW"
      },
      {
        path: "category",
        name: "Danh mục sản phẩm",
        meta: { title: 'Danh mục sản phẩm', icon: 'icon-logistics-box'},
        component: () => import("@/pages/items/category"),
        permission: "NSH_ITEM_CATEG_VIEW"
      },
      {
        path: "unit",
        name: "Đơn vị tính",
        meta: { title: 'Đơn vị tính', icon: 'icon-logistics-box'},
        component: () => import("@/pages/items/unit"),
        permission: "NSH_ITEM_PROD_CREATE"
      },
      {
        path: "brand",
        name: "Thương hiệu",
        meta: { title: 'Thương hiệu', icon: 'icon-logistics-box'},
        component: () => import("@/pages/items/brand"),
        permission: "NSH_ITEM_PROD_CREATE"
      },
      {
        path: "warranty",
        name: "Chính sách bảo hành",
        meta: { title: 'Chính sách bảo hành'},
        component: () => import("@/pages/items/warranty"),
        permission: "NSH_ITEM_PROD_CREATE"
      },
      {
        path: "/barcode/choose",
        name: "In mã vạch",
        meta: { title: 'In mã vạch'},
        component: () => import("@/pages/barcode/choose.vue"),
        permission: "NSH_ITEM_PROD_CREATE"
      }
    ]
  },
  {
    path: "/items/batch-detail/:batchCode/:sku",
    name: "Chi tiết lô và HSD",
    meta: { title: 'Chi tiết lô và HSD', icon: ''},
    component: () => import("@/pages/items/batch-detail"),
  },
  {
    path: "/items",
    name: "Sản phẩm",
    hidden: true,
    meta: { title: 'Sản phẩm', icon: 'icon-logistics-box' },
    component: LayoutDefault,
    children: [
      {
        path: "items-edit-inventory/:id",
        name: "Chỉnh sửa tồn kho",
        meta: { title: 'Điều chỉnh tồn kho', icon: ''},
        hidden: true,
        component: () => import("@/pages/items/items-edit-inventory"),
      },
      {
        path: "items-add",
        name: "Thêm mới sản phẩm",
        meta: { title: 'Thêm mới sản phẩm', icon: ''},
        component: () => import("@/pages/items/items-add"),
      },
      {
        path: "items-detail/:id",
        name: "Chi tiết sản phẩm",
        meta: { title: 'Chi tiết sản phẩm', icon: '' },
        component: () => import("@/pages/items/items-detail"),
      },
      {
        path: "update-item-variations/:id",
        name: "Chỉnh sửa phiên bản",
        meta: { title: 'Chi tiết sản phẩm', icon: '' },
        component: () => import("@/pages/items/update-item-variations"),
      },
      {
        path: "update-item-inventory/:id",
        name: "Chỉnh sửa tồn kho",
        meta: { title: 'Chi tiết sản phẩm', icon: '' },
        component: () => import("@/pages/items/update-item-inventory"),
      },
      {
        path: "update-item-info/:id",
        name: "Chỉnh sửa thông tin chung",
        meta: { title: 'Chi tiết sản phẩm', icon: '' },
        component: () => import("@/pages/items/update-item-info"),
      },
    ]
  },
  {
    path: "/inventory-list",
    name: "Kho & Tồn",
    meta: { title: 'Kho & Tồn', icon: 'fa-box' },
    component: Layout,
    listPermission: ["NSH_INV_VIEW", "NSH_MCMNT_MERCHANT_UPDATE", "NSH_INV_ITEM_VIEW", "NSH_ODM_IO_VIEW"],
    children: [
      {
        path: "",
        name: "Quản lý kho",
        meta: { title: 'Quản lý kho'},
        component: () => import("@/pages/inventory/inventory-list"),
        permission: "NSH_INV_VIEW"
      },
      {
        path: "/inventory-detail/:storageId",
        name: "Tồn kho",
        meta: { title: 'Tồn kho'},
        hidden: true,
        component: () => import("@/pages/inventory/inventory-detail.vue"),
        permission: "NSH_INV_ITEM_VIEW"
      },
      {
        path: "/inventory-detail",
        name: "Tồn kho",
        meta: { title: 'Tồn kho'},
        component: () => import("@/pages/inventory/inventory-detail.vue"),
        permission: "NSH_INV_ITEM_VIEW"
      },
      {
        path: "/inventory-checkin",
        name: "Nhập kho",
        meta: { title: 'Nhập kho'},
        component: () => import("@/pages/inventory/inventory-checkin"),
        permission: "NSH_ODM_IO_VIEW"
      },
      {
        path: "/inventory-checkout",
        name: "Xuất kho",
        meta: { title: 'Xuất kho'},
        component: () => import("@/pages/inventory/inventory-checkout"),
        permission: "NSH_ODM_CO_VIEW"
      },
      {
        path: "/inventory-trans",
        name: "Chuyển kho",
        meta: { title: 'Chuyển kho'},
        component: () => import("@/pages/inventory/inventory-trans"),
        permission: "NSH_ODM_TF_VIEW"
      },
      {
        path: `/inventory-active`,
        name: "Active tính năng kho",
        hidden: true,
        meta: { title: 'Chuyển kho'},
        component: () => import("@/pages/inventory/inventory-active.vue")
      }
    ]
  },
  {
    path: "/",
    name: "Nhập kho",
    meta: { title: 'Nhập kho', icon: 'icon-logistics-box' },
    component: LayoutDefault,
    hidden: true,
    children: [
      {
        path: "/storage-create",
        name: "Tạo đơn nhập kho",
        meta: { title: 'Tạo đơn nhập kho'},
        component: () => import("@/pages/storage/storage-create"),
      },
      {
        path: `/storage-create/:itemID`,
        name: "Tạo đơn nhập kho",
        component: () => import('@/pages/storage/storage-create'),
      },
      {
        path: `${API_STORAGE_DETAIL}/:documentID`,
        name: "Thông tin đơn nhập kho",
        component: () => import('@/pages/storage/components/storage-detail.vue'),
      },
      {
        path: `${API_STORAGE_IMPORT}/:documentID`,
        name: "Nhập kho",
        component: () => import('@/pages/storage/components/storage-detail.vue'),
      },
      {
        path: `${API_STORAGE_UPDATE}/:documentID`,
        name: "Cập nhật đơn nhập kho",
        component: () => import('@/pages/inventory/inventory-order'),
      },
      {
        path: `${API_STORAGE_RECREATE}/:documentID`,
        name: "Đặt lại đơn nhập kho",
        component: () => import('@/pages/inventory/inventory-order'),
      },
      {
        path: `${API_STORAGE_SUCCESS}/:documentID`,
        name: "Hoàn thành đơn nhập kho",
        component: () => import('@/pages/storage/components/storage-detail.vue'),
      },
      {
        path: `${API_STORAGE_CANCEL}/:documentID`,
        name: "Hủy đơn nhập kho",
        component: () => import('@/pages/storage/components/storage-detail.vue'),
      },
    ]
  },
  {
    path: "/",
    name: "Chuyển kho",
    meta: { title: 'Chuyển kho', icon: 'icon-logistics-box' },
    component: LayoutDefault,
    hidden: true,
    children: [
      {
        path: `${API_SWITCH_STORAGE_CREATE}`,
        name: "Tạo đơn chuyển kho",
        component: () => import('@/pages/storage/switch/create.vue'),
      },
      {
        path: `${API_SWITCH_STORAGE_EDIT}/:documentID`,
        name: "Chỉnh sửa đơn chuyển kho",
        component: () => import('@/pages/storage/switch/create.vue'),
      },
      {
        path: `${API_SWITCH_STORAGE_DETAIL}/:documentID`,
        name: "Thông tin đơn chuyển kho",
        component: () => import('@/pages/storage/switch/detail.vue'),
      },
      {
        path: `${API_EXPORT_STORAGE_DETAIL}/:documentID`,
        name: "Thông tin đơn xuất kho",
        component: () => import('@/pages/storage/switch/export-detail.vue'),
      },
      {
        path: `${API_IMPORT_STORAGE_DETAIL}/:documentID`,
        name: "Thông tin đơn nhập kho",
        component: () => import('@/pages/storage/switch/export-detail.vue'),
      },
    ]
  },
  {
    path: "/next-lend",
    name: "Ứng vốn",
    meta: { title: 'Ứng vốn', icon: 'fa-credit-card'},
    href: `https://nextlend.vn/`,
    component: Layout,
    listPermission: []
  },
  {
    path: "/debt_list",
    name: "Sổ công nợ",
    meta: { title: 'Sổ công nợ', icon: 'fa-money-check-dollar' },
    component: Layout,
    listPermission: ["NSH_DEBT_VIEW"],
    children: [
      {
        path: "/debtList_recovery",
        name: "Khoản phải thu",
        meta: { title: 'Khoản phải thu'},
        component: () => import("@/pages/debtnote/new/debtList_recovery_v3"),
        permission: "NSH_DEBT_VIEW",
      },
      {
        path: "/debtList_repay",
        name: "Khoản phải trả",
        meta: { title: 'Khoản phải trả'},
        component: () => import("@/pages/debtnote/new/debtList_repay_v3"),
        permission: "NSH_INV_VIEW",
      }
    ]
  },
  {
    path: `/debt_detail`,
    name: "Chi tiết công nợ",
    component: LayoutDefault,
    hidden: true,
    children: [
      {
        path: ":id",
        name: "Chi tiết công nợ",
        component: () => import("@/pages/debtnote/new/debt_detail_v3"),
      }
    ]
  },
  {
    path: "/customer-list",
    name: "Khách hàng",
    meta: { title: 'Khách hàng', icon: 'fa-users-rectangle' },
    component: Layout,
    listPermission: ["NSH_PARTNER_CUS_VIEW", "NSH_PARTNER_GROUP_CUS_VIEW"],
    children: [
      {
        path: "",
        name: "Quản lý khách hàng",
        meta: { title: 'Quản lý khách hàng'},
        component: () => import("@/pages/customer/customer-list"),
        permission: "NSH_PARTNER_CUS_VIEW"
      },
      {
        path: "/group-customer",
        name: "Quản lý nhóm khách hàng",
        hidden: true,
        meta: { title: 'Quản lý nhóm khách hàng'},
        component: () => import("@/pages/customer/group-customer-list"),
        permission: "NSH_PARTNER_GROUP_CUS_VIEW"
      }
    ]
  },
  {
    path: "/customer-list",
    name: "Khách hàng",
    meta: { title: 'Khách hàng', icon: 'fa-users-rectangle' },
    component: LayoutDefault,
    listPermission: ["NSH_PARTNER_CUS_VIEW", "NSH_PARTNER_GROUP_CUS_VIEW"],
    children: [
      {
        path: "customer-add",
        name: "Thêm mới khách hàng",
        hidden: true,
        meta: { title: 'Thêm mới khách hàng'},
        component: () => import("@/pages/customer/customer-add")
      },
      {
        path: "customer-edit/:id",
        name: "Cập nhật khách hàng",
        hidden: true,
        meta: { title: 'Cập nhật khách hàng'},
        component: () => import("@/pages/customer/customer-edit")
      },
      {
        path: "customer-detail/:id",
        name: "Thông tin khách hàng",
        hidden: true,
        meta: { title: 'Thông tin khách hàng'},
        component: () => import("@/pages/customer/customer-detail")
      }
    ]
  },
  {
    path: "/employee-and-role",
    name: "Tài khoản nhân viên",
    meta: { title: 'Tài khoản nhân viên', icon: 'fa-address-card' },
    component: Layout,
    listPermission: ["NSH_MCMNT_ALIAS_VIEW", "NSH_IAM_ROLE_VIEW"],
    children: [
      {
        path: "",
        name: "Tài khoản nhân viên",
        meta: { title: 'Tài khoản nhân viên', icon: 'fa-address-card' },
        component: () => import("@/pages/employee/employee-and-role"),
        permission: "NSH_IAM_ROLE_VIEW"
      },
    ]
  },
  {
    path: "/supplier-list",
    name: "Nhà cung cấp",
    meta: { title: 'Nhà cung cấp', icon: 'fa-warehouse' },
    component: Layout,
    listPermission: ["NSH_PARTNER_SUP_VIEW", "NSH_PARTNER_GROUP_SUP_VIEW"],
    children: [
      {
        path: "/",
        name: "Danh sách nhà cung cấp",
        meta: { title: 'Danh sách nhà cung cấp'},
        component: () => import("@/pages/suppliers/supplier-list-v2"),
        permission: "NSH_PARTNER_SUP_VIEW"
      },
      {
        path: "/group-supplier",
        name: "Quản lý nhóm nhà cung cấp",
        meta: { title: 'Quản lý nhóm nhà cung cấp'},
        component: () => import("@/pages/suppliers/group-supplier-list"),
        permission: "NSH_PARTNER_GROUP_SUP_VIEW",
        hidden: true,
      },
      {
        path: "/group-supplierv2",
        name: "Quản lý nhóm nhà cung cấp",
        meta: { title: 'Quản lý nhóm nhà cung cấp'},
        component: () => import("@/pages/suppliers/supplier-group-list-v2"),
        permission: "NSH_PARTNER_GROUP_SUP_VIEW",
        hidden: true,
      }
    ]
  },
  {
    path: `/supplier-list/supplier-add`,
    name: "Thêm nhà cung cấp",
    component: () => import("@/pages/suppliers/supplier-add"),
    hidden: true,
  },
  {
    path: `/supplier-list/supplier-edit/:id`,
    name: "Sửa nhà cung cấp",
    component: () => import("@/pages/suppliers/supplier-edit"),
    hidden: true,
  },
  {
    path: `/supplier-list/supplier-detail/:id`,
    name: "Chi tiết nhà cung cấp",
    component: () => import("@/pages/suppliers/supplier-detail"),
    hidden: true,
  },
  //New Role
  {
    path: "/employee-and-role",
    name: "Quyền người dùng",
    hidden: true,
    component: LayoutDefault,
    children: [
      {
        path: "role-create",
        name: "Thêm mới quyền",
        component: () => import("@/pages/role/role-create-v2"),
      },
      {
        path: "role-edit/:id",
        name: "Cập nhật thông tin quyền",
        component: () => import("@/pages/role/role-edit-v2"),
      },
      {
        path: "employee-create",
        name: "Thêm thông tin nhân viên",
        hidden: true,
        meta: { title: 'Thêm thông tin nhân viên'},
        component: () => import("@/pages/employee/employee-create-v2"),
      },
      {
        path: "employee-detail/:id",
        name: "Thông tin nhân viên",
        hidden: true,
        meta: { title: 'Thông tin nhân viên'},
        component: () => import("@/pages/employee/employee-detail-v2"),
      },
      {
        path: "employee-role-edit/:id",
        name: "Sửa vai trò",
        hidden: true,
        meta: { title: 'Sửa vai trò'},
        component: () => import("@/pages/employee/employee-role-edit"),
      },
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]
const createRouter = () => new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})
const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router